module.exports = __webpack_public_path__ + "img/align_right.cb5546a0.svg";